module.exports = __webpack_public_path__ + "static/img/noorder.1cbed22a.svg";